export default "__VITE_ASSET__dabb39ab__"